/**
 * fetch( 链接, 参数, 方法, 是否需要token )
**/
import http from './public'
// 商品列表
export const getAllGoods = (params) => {
  const data = {
    ...params,
    is_point: false
  }
  return http.fetch('api/h5app/wxapp/goods/items', data, 'GET', true)
}

export const getAllCouponGoods = (params) => {
  return http.fetch('api/h5app/wxapp/goods/items/card_id', params, 'GET', true)
}
// 获取购物车列表
export const getCartList = (params) => {
  return http.fetch('api/h5app/wxapp/cart/list', params, 'GET', true)
}
// 获取购物车数量
export function getCartCount (params) {
  return http.fetch('api/h5app/wxapp/cartcount',params,'GET',true)
}
// 加入购物车
export const addCart = (params) => {
  return http.fetch('api/h5app/wxapp/cart', params, 'POST', true)
}
// 勾选购物车
export const checkCart = (params) => {
  return http.fetch('api/h5app/wxapp/cartupdate/checkstatus', params, 'PUT', true)
}
// 编辑数量
export const editCart = (params) => {
  return http.fetch('api/h5app/wxapp/cartupdate/num', params, 'PUT', true)
}
// 删除整条购物车
export const cartDel = (params) => {
  return http.fetch('api/h5app/wxapp/cartdel', params, 'DELETE', true)
}
// 地区json
export const regionList = (params) => {
  // return http.fetch('api/h5app/wxapp/member/addressarea', params, 'GET')
  return http.fetch('api/h5app/wxapp/espier/address', params, 'GET')
}
// 获取用户地址
export const addressList = (params) => {
  return http.fetch('api/h5app/wxapp/member/addresslist', params, 'GET', true)
}
// 通过id获取地址
export const getAddress = (params) => {
  return http.fetch('/member/address', params, 'POST', true)
}
// 修改收货地址
export const addressUpdate = (params, id) => {
  return http.fetch(`api/h5app/wxapp/member/address/${id}`, params, 'PUT', true)
}
// 添加收货地址
export const addressAdd = (params) => {
  return http.fetch('api/h5app/wxapp/member/address', params, 'POST', true)
}
// 删除收货地址
export const addressDel = (params, id) => {
  return http.fetch(`api/h5app/wxapp/member/address/${id}`, params, 'DELETE', true)
}
// 获取订单优惠以及运费信息
export const getFreightFee = (params) => {
  return http.fetch('api/h5app/wxapp/getFreightFee', params, 'POST', true)
}
// 创建订单
export const submitOrder = (params) => {
  return http.fetch('api/h5app/wxapp/order_new', params, 'POST', true)
}
// 支付
export const payMent = (params) => {
  return http.fetch('api/h5app/wxapp/payment', params, 'POST', true)
}
// 获取用户订单
export const orderList = (params) => {
  return http.fetch('api/h5app/wxapp/orders', params, 'GET', true)
}
//  获取订单详情
export const getOrderInfo = (params, id) => {
  return http.fetch(`api/h5app/wxapp/order/${id}`, params, 'GET', true)
}
// 获取订单信息
export const getOrderDet = (params, id) => {
  return http.fetch(`api/h5app/wxapp/order_new/${id}`, params, 'GET', true)
}
// 取消订单
export const cancelOrder = (params) => {
  return http.fetch('api/h5app/wxapp/order/cancel', params, 'POST', true)
}
// 确认收货
export const confirmOrder = (params) => {
  return http.fetch('api/h5app/wxapp/order/confirmReceipt', params, 'POST', true)
}
// 处方药数量
export const getRxNum = (params, id) => {
  return http.fetch(`api/h5app/wxapp/cartcount`, params, 'GET', true)
}
// 处方药需求清单数量
export const productDet = (params, id) => {
  return http.fetch(`api/h5app/wxapp/goods/items/${id}`, params, 'GET', true)
}
// 删除订单
export const delOrder = (params) => {
  return http.fetch('/member/delOrder', params, 'GET', true)
}
// 商品列表
export const getSearch = (params) => {
  return http.fetch('/goods/search', params, 'GET')
}
// 快速搜索
export const getQuickSearch = (params) => {
  return http.fetch('/goods/quickSearch', params, 'GET')
}
// 收藏商品
export const addCollection = (params, id) => {
  return http.fetch(`api/h5app/wxapp/member/collect/item/${id}`, params, 'POST', true)
}
// 取消收藏
export const removeCollection = (params) => {
  return http.fetch(`api/h5app/wxapp/member/collect/item`, params, 'DELETE', true, 'special')
}
// 获取收藏列表
export const getCollectionList = (params) => {
  return http.fetch(`api/h5app/wxapp/member/collect/item`, params, 'GET', true)
}
// 获取模版信息
export const getParamByTempName = (params) => {
  return http.fetch(`api/h5app/wxapp/pageparams/setting`, params, 'GET')
}
// sku商品活动
export const getskumarketing = (params) => {
  return http.fetch(`api/h5app/wxapp/promotion/getskumarketing`, params, 'GET', true)
}
// 组合menu列表
export const getPackageMenuList = (params) => {
  return http.fetch(`api/h5app/wxapp/promotions/package`, params, 'GET')
}
// 组合商品列表
export const getPackageList = (params, id) => {
  return http.fetch(`api/h5app/wxapp/promotions/package/${id}`, params, 'GET')
}
// 获取售后列表
export const getAftersalesList = (params) => {
  return http.fetch(`api/h5app/wxapp/aftersales`, params, 'GET', true)
}
// 发起售后
export const applyAftersales = (params) => {
  return http.fetch(`api/h5app/wxapp/aftersales`, params, 'POST', true)
}
// 获取售后详情
export const getAftersalesInfo = (params) => {
  return http.fetch(`api/h5app/wxapp/aftersales/info`, params, 'GET', true)
}
// 取消售后
export const removeClose = (params) => {
  return http.fetch(`api/h5app/wxapp/aftersales/close`, params, 'POST', true)
}
// 发送售后物流
export const sendback = (params) => {
  return http.fetch(`api/h5app/wxapp/aftersales/sendback`, params, 'POST', true)
}
// 修改售后信息
export const editModify = (params) => {
  return http.fetch(`/api/h5app/wxapp/aftersales/modify`, params, 'POST', true)
}
// 获取vip充值列表
export const getVipNewlist = (params) => {
  return http.fetch(`/api/h5app/wxapp/vipgrades/newlist`, params, 'GET', true)
}
// 生成VIP订单
export const submitOrderBuy = (params) => {
  return http.fetch(`/api/h5app/wxapp/vipgrades/buy`, params, 'POST', true)
}
// 获取用户已经领取的优惠卷
export const getNewGetCardList = (params) => {
  return http.fetch(`/api/h5app/wxapp/user/newGetCardList`, params, 'GET', true)
}

//收藏店铺
export const collectShop = (params, id) => {
    return http.fetch(`api/h5app/wxapp/member/collect/distribution/${id}`,  params, 'POST', true)
}

//取消收藏店铺
export const cancelShop = (params, id) => {
    return http.fetch(`api/h5app/wxapp/member/collect/distribution`, params, 'DELETE', true, 'special')
}
//收藏店铺列表
export const getCollectionShop = (params) => {
    return http.fetch(`api/h5app/wxapp/member/collect/distribution`, params, 'GET', true)
}
//获取活动详情
export const getPromotionInfo = (params) => {
  return http.fetch(`api/h5app/wxapp/promotion/fullpromotion/getitemlist`, params, 'GET', true)
}
//获取物流详情
export const getTrackerpull = (params) => {
  return http.fetch(`api/h5app/wxapp/trackerpull`, params, 'GET', true)
}
//获取优惠卷详情
export const getCardDetail = (params, id) => {
  return http.fetch(`api/h5app/wxapp/getCardDetail/${id}`, params, 'GET', true)
}
//获取优惠卷详情
export const getPcqrCodePng = (params) => {
  return http.fetch(`/h5app/wechatAuth/wxapp/pcqrcode.png`, params, 'GET', false)
}



// WEBPACK FOOTER //
// ./src/api/goods.js